export default "__VITE_ASSET__9726a239__"